<button class="icon-btn flex sm:hidden mr-5" (click)="toggleMenu.set(!toggleMenu())">
  <i class="material-icons">menu</i>
</button>

<app-bread-crumb class="mr-auto ml-4 min-w-max" (pathClicked)="toggleMenu.set(false)"></app-bread-crumb>

@if(companyService.companies().length) {
  <app-company-picker></app-company-picker>
}

<div class="profile-links min-w-max ml-2.5">
  <app-links></app-links>
</div>

<div class="profile-control profile-links small">
  <div class="user-avatar" [matMenuTriggerFor]="menu" (click)='changeState($event, 1)'>
    {{user().FirstName.charAt(0)}}{{user().LastName.charAt(0)}}
  </div>
  <!-- <div class="img-holder" >
  <img [src]="profilePic">
</div> -->
<mat-menu class="user-menu" #menu="matMenu">
  <div class="user-menu">

    @if (status() === 1) {
      <div>
        <div class="user-info">
          <span mat-menu-item class="user-name">{{user().FirstName}} {{user().LastName}}</span>
          <span mat-menu-item class="user-company">Evertracker</span>
        </div>
        <mat-divider></mat-divider>
        <div (click)="changeState($event, 2)" mat-menu-item class="user-menu-item">
          {{'main.user-menu.language' | translate}}
          <i class="material-icons">chevron_right</i>
        </div>
        <mat-divider></mat-divider>
        <a [routerLink]="['/account-settings']" mat-menu-item >{{'main.user-menu.acc' | translate}}</a>
        <mat-divider></mat-divider><!--
        <a [routerLink]="['/team-settings']" mat-menu-item >{{'main.user-menu.team' | translate}}</a>-->
        <mat-divider></mat-divider>
        <a (click)="logOut()" mat-menu-item>{{'main.button.log-out' | translate}}</a>
      </div>
    }

    @if (status() === 2) {
      <div>
        <div mat-menu-item (click)="changeState($event, 1)" class="user-menu-item start l14">
          <i class="material-icons mr-1.5">chevron_left</i>Back
        </div>
        <div class="selected-lang flex items-center justify-between l14" (click)="$event.stopPropagation()">
          {{'main.user-menu.selected' | translate}} <img [src]="'assets/flags/' + lnFlag()" class="ml-2.5">
        </div>
        @for (lang of languages; track lang) {
          <mat-divider></mat-divider>
          <div mat-menu-item class="user-menu-item" (click)="setLanguage(lang)">
            {{lang.name}}
            <img [src]="'assets/flags/' + lang.flag" class="ml-2.5">
          </div>
        }
      </div>
    }

  </div>
</mat-menu>
</div>

<button class="notification hidden" (click)="notificationToggle.emit()">
  <!-- <i class="material-icons">notifications</i> -->
  <img class="notification-icon" src="../../assets/icons/bell.svg" alt="bell">
  @if (unreadNotifications()) {
    <span class="unread">{{unreadNotifications()}}</span>
  }
</button>


